import { WireCompanyModelDto } from '@treasury/api/channel';

export const nullWireCompany: WireCompanyModelDto = {
    id: 0,
    updatedDate: '0001-01-01T00:00:00',
    name: '',
    isDliWireCompany: false,
};
